import { BuyButtonForm } from "../../../../../components/common/BuyButton/v2/models/BuyButtonForm";

type Product = { numericId: string; title: string };

const brandMap = {
  survaq: "SurvaQサテライト",
  calqs: "CALQSサテライト",
} as const;

type Store = keyof typeof brandMap;

export const viewItem = (form: BuyButtonForm, product: Product | null, store: Store) => {
  // @ts-expect-error
  window.gtag?.("event", "view_item", {
    currency: "JPY",
    value: form.totalPrice,
    ...(product ? { items: buildItems(form, product, store) } : {}),
    non_interaction: true,
  });
};

export const addToCart = (form: BuyButtonForm, product: Product | null, store: Store) => {
  // @ts-expect-error
  window.gtag?.("event", "add_to_cart", {
    currency: "JPY",
    value: form.totalPrice,
    ...(product ? { items: buildItems(form, product, store) } : {}),
  });
};

const buildItems = (form: BuyButtonForm, product: Product, store: Store) => {
  const variant = form.getSelectedVariantByProductId(product.numericId);
  return [
    {
      item_id: variant
        ? `shopify_JP_${product.numericId}_${variant.id}`
        : `shopify_JP_${product.numericId}`,
      item_name: variant ? `${product.title} - ${variant.title}` : product.title,
      item_brand: brandMap[store],
      price: variant?.price ?? form.totalPrice,
      ...(variant ? { item_variant: variant.title } : {}),
    },
  ];
};
